import React from 'react'
import strings from '../../lang/strings'
import { formatNumber } from '../../helper/common'
import { FORMAT } from '../../config/const'

export default function ItemCoupon(props) {
  const { info } = props
  return (
    <div className={'coupon-item mb-14 d-flex'}>
      <div className='flex-full'>
        <div className='fs-24 sm-fs-20 color-3a3335 f-sb'>{formatNumber(info.cp_price) + strings.won}</div>
        <div className='fs-14 sm-fs-14 f-m color-9e9e9e'>{info.cp_name}</div>
        <div className='d-flex-block mt-40 sm-mt-20'>
          <div className='d-flex'>
            <div className='fs-12 color-9e9e9e'>{strings.open_date}</div>
            <div className='fs-12 color-3a3335 ml-6'>{info.cp_createdat.dateFormat(FORMAT.DATE)}</div>
          </div>
          <div className='fs-12 sm-fs-10 color-ededed mh-14 sm-none'>{'|'}</div>
          <div className='d-flex sm-mt-6'>
            <div className='fs-12 color-9e9e9e'>{strings.close_date}</div>
            <div className='fs-12 color-3a3335 ml-8'>{info.cp_expire.dateFormat(FORMAT.DATE)}</div>
          </div>
        </div>
      </div>
      <div className='align-self-center text-center'>
        <img className='' src={'/assets/image/chk5.png'} alt='' width={24} />
        <div className='fs-12 color-9e9e9e mt-6'>{strings.use_available}</div>
      </div>
    </div>
  )
}

